import { call, put } from 'redux-saga/effects';

import UserClient from '../../api/UserClient';
import { userResetPasswordSuccessful, userResetPasswordFailed } from '../../redux/user/actions';
import { messagesShow } from '../../redux/messages/actions';

/** The message shown for each API `message_code` a reset can be refused with. */
const PASSWORD_ERROR_MESSAGES = {
    BadPasswordWeak: 'errorPasswordTooWeak',
    ReusingPassword: 'errorReusingPassword',
};

/**
 * The `message_code` of an API 400, whose body carries a JSON string in its
 * `message`. Any other 400 body — a token endpoint refusing the anonymous
 * client answers `{ error, error_description }` — has none.
 *
 * @param {*} body The 400 response body, as `ApiClient.customReject` passes it.
 * @returns {(string|null)} The message code, or null.
 */
const apiMessageCode = body => {
    if (!body || typeof body.message !== 'string') return null;
    try {
        const parsed = JSON.parse(body.message);
        return (parsed && parsed.error && parsed.message_code) || null;
    } catch (error) {
        return null;
    }
};

export default function*({ payload: { token, password } }) {
    try {
        yield call(UserClient.resetLostPassword, token, password);
        yield put(userResetPasswordSuccessful());
        yield put(messagesShow('resetPasswordSuccefull', 'success'));
    } catch (data) {
        // The call goes through the anonymous client, so a 401 is not a lost
        // user session: it falls through to the generic error, no sign-out.
        const { code } = data;
        if (code === 400) {
            const messageCode = apiMessageCode(data.message);
            yield put(userResetPasswordFailed());
            yield put(messagesShow(PASSWORD_ERROR_MESSAGES[messageCode] || 'internalServerError', 'error'));
        } else if (code === 424) {
            yield put(userResetPasswordFailed());
            yield put(messagesShow('loginNotExist', 'error'));
        } else {
            yield put(userResetPasswordFailed());
            yield put(messagesShow('internalServerError', 'error'));
        }
    }
}
